module.exports = __webpack_public_path__ + "themify.e23a7dcaefbde4e74e26.ttf";


//////////////////
// WEBPACK FOOTER
// D:/projects/feelway-pawnshop/pawnshop-web-client-feelway/src/assets/scss/icons/themify-icons/fonts/themify.ttf
// module id = ../../../../../src/assets/scss/icons/themify-icons/fonts/themify.ttf
// module chunks = styles